export const DEFAULT_INTEGRATIONS = ['bokio', 'dooer', 'speedledger'];
